import { BlastEvent, SimulationConfig } from '@/types';
import { getRadiusAtAngle } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const VolcanicBurstAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number,
  timeSeconds: number
) => {
  const useRGB = config.rgbLighting && config.useFXRGB && !config.blastMatchRingColor;
  const t = timeSeconds;
  if (useRGB) ctx.fillStyle = `hsl(${(progress * 80 + 10) % 360}, 100%, 50%)`;
  for (let i = 0; i < 40; i++) {
    const a = (i / 40) * Math.PI * 2;
    const r = getRadiusAtAngle(a, e, e.maxRadius);
    const bx = Math.cos(a) * r;
    const by = Math.sin(a) * r;
    const v = 300 + Math.random() * 800;
    const d = t * v;
    const gy = 1500 * t * t;
    ctx.beginPath(); ctx.arc(e.pos.x + bx + Math.cos(a)*d, e.pos.y + by + Math.sin(a)*d + gy, 6 * (1 - progress), 0, Math.PI * 2); ctx.fill();
  }
};

registerBlastAnimation('VOLCANIC_BURST', VolcanicBurstAnimation);
